import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CartProvider } from "./Component/CartContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<CartProvider> <App /> </CartProvider>);


reportWebVitals();
